export interface EquipmentSearch {
  equipmentUsageID: string | null;
  equipmentDispatchID: string | null;
  equipmentID: string | null;
  equipment: string | null;
  equipmentName: string | null;
  dateUsed: Date | null;
  shift: number | null;
  altID: string | null;
  amount: number | null;
  billingRate: number | null;
  unitName: string | null;
  customerPO: string | null;
  workOrder: string | null;
  workOrderDescription: string | null;
  timeSheetID: string | null;
  timeSheetName: string | null;
  dateExported: Date | null;
  bActive: boolean | null;
  billingTemplate: string | null;
  equipmentBillingID: string | null;
  dateReallocated: Date | null;
  reallocatedBy: string | null;
}
